<template lang="pug">
v-card.mb-3
  v-card-title.title.grey.lighten-4 {{extra && extra.name || 'Ticket Center'}}
  v-card-text
    template(v-if="!user")
      | Bitte anmelden
    template(v-if="!isTicketer")
    template(v-else)
      v-layout(wrap)
        v-flex(xs12 md4 lg2)
          v-select(label="Status" v-model="status" :items="statusOptions" clearable)
        v-flex(xs12 md4 lg2)
          v-autocomplete(label="Bearbeiter" v-model="bearbeiterId" :items="ticketBearbeiter" item-text="vollerName" item-value="id" clearable)
        v-flex(xs12 md4 lg2)
          v-text-field(label="Ersteller" v-model="ersteller" clearable)
        v-flex(xs12 md4 lg2)
          v-select(label="Prio" v-model="prio" :items="prioOptions" clearable)
        v-flex(xs12 md4 lg2)
          v-autocomplete(label="Projekt" v-model="projektId" :items="projekte" item-text="namePnr" item-value="id" clearable)
        v-flex(xs12 md4 lg2)
          v-text-field(label="Suche" v-model="suche" clearable)

        v-flex(xs12)
          v-tabs(lazy v-model="activeTab")
            template(v-for="ticketType in ticketTypes")
              v-tab {{ticketType}}
          v-data-table(:items="itTickets" :headers="ticketsHeader" must-sort :pagination.sync="ticketsPagination" :loading="$apollo.queries.itTickets.loading")
            template(v-slot:items="{ item }")
              td: a(:href="`/admin/it_tickets/${item.id}/edit`") {{ item.id }}
              td {{ item.prio }}
              td {{ item.statusHuman }}
              td {{ item.betreff }}
              td {{ item.email }}
              td {{ item.bearbeiter && item.bearbeiter.vollerName }}
              td: v-tooltip(top)
                span(slot="activator") {{ formatDate(item.updatedAt) }}
                | {{ formatDateLong(item.updatedAt) }}
              td: v-tooltip(top)
                span(slot="activator") {{ formatDate(item.createdAt) }}
                | {{ formatDateLong(item.createdAt) }}

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import moment from 'moment'
import { sortBy, uniq, flatten } from 'lodash'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    const ticketsPagination = {
      descending: true,
      rowsPerPage: 10,
      sortBy: 'updatedAt'
    }
    return {
      activeTab: 0,
      status: "neu",
      prio: null,
      bearbeiterId: null,
      ersteller: '',
      projektId: null,
      suche: '',
      itTickets: [],
      ticketsPagination,
      myPagination: { ...ticketsPagination },
      prioPagination: { ...ticketsPagination },
      oldPagination: { ...ticketsPagination },
      otherPagination: { ...ticketsPagination },
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Geschlossen', value: 'geschlossen' },
        { text: 'Telekommunikation', value: 'telekommunikation' },
      ],
      prioOptions: [
        { text: '5 Kritisch', value: 5 },
        { text: '4 Hoch', value: 4 },
        { text: '3 Normal', value: 3 },
        { text: '2 Niedrig', value: 2 },
        { text: '1 NiceToHave', value: 1 },
      ],
      ticketsHeader: [
        { text: 'ID', value: 'id' },
        { text: 'Prio', value: 'prio' },
        { text: 'Status', value: 'statusHuman' },
        { text: 'Betreff', value: 'betreff' },
        { text: 'Ersteller', value: 'email' },
        { text: 'Bearbeiter', value: 'bearbeiter.vollerName' },
        { text: 'Änd.', value: 'updatedAt' },
        { text: 'Erst.', value: 'createdAt' },
      ],
      ticketTypes: [
        'Meine Tickets',
        'Prio 4-5',
        '14-30 Tage',
        'älter als 30 Tage',
        'ohne Bearbeiter',
        'Alle',
      ],
    }
  },
  apollo: {
    itTickets: {
      fetchPolicy: 'cache-and-network',
      query: gql`query ExtraItTicketCenterTickets($q: String) {
        itTickets(q: $q) {
          id
          status
          statusHuman
          betreff
          updatedAt
          prio
          email
          person {
            id
            vollerName
          }
          bearbeiter {
            id
            vollerName
          }
        }
      }`,
      variables() {
        const q = {
          status_eq: this.status === 'geschlossen' ? null : this.status,
          status_not_in: this.status !== 'geschlossen' ? null : this.statusOptions.map((s) => s.value).filter((s) => s !== 'geschlossen'),
          prio_eq: this.prio,
          bearbeiter_id_eq: this.bearbeiterId,
          email_contains: this.ersteller || null,
          personen_projekte_id_eq: this.projektId,
          texte_cont: this.suche || null,
          is_blacklisted: false,
        }
        const tab = this.activeTab
        if (tab === 0) {
          q.bearbeiter_id_eq = this.myId
        } else if (tab === 1) {
          q.prio_in = [4, 5]
        } else if (tab === 2) {
          q.updated_at_lteq = moment().subtract(14, 'days')
          q.updated_at_gteq = moment().subtract(30, 'days')
        } else if (tab === 3) {
          q.updated_at_lt = moment().subtract(30, 'days')
        } else if (tab === 4) {
          q.bearbeiter_id_eq = null
          q.bearbeiter_id_null = true
        }
        return { q: JSON.stringify(q) }
      },
    },
    ticketBearbeiter: {
      query: gql`query ExtraItTicketCenterBearbeiter {
        ticketBearbeiter: personen(where: { ticketBearbeiter: true }) {
          id
          vollerName
        }
      }`,
    },
    projekte: {
      query: gql`query ExtraItTicketCenterprojekte {
        projekte {
          id
          namePnr
        }
      }`,
    },
    user: {
      query: gql`query ExtraProjekteStatusUser {
        user: currentUser {
          id
          person {
            id
            ticketBearbeiter
          }
        }
      }`,
    }
  },
  computed: {
    myId() {
      const user = this.user
      return user && user.person && user.person.id && `${user.person.id}`
    },
    filteredTickets() {
      let tickets = this.itTickets
      return tickets
    },
    myTickets() {
      const userId = this.user && this.user.person && this.user.person.id || 0
      return this.itTickets.filter((t) => t.bearbeiter && t.bearbeiter.id == userId)
    },
    prioTickets() {
      return this.itTickets.filter((t) => t.prio >= 4)
    },
    oldTickets() {
      const tooOld = Date.now() - 1000*60*60*24* 14
      return this.itTickets.filter((t) => t.updatedAt <= tooOld)
    },
    otherTickets() {
      const userId = this.user && this.user.person && this.user.person.id || 0
      const tooOld = Date.now() - 1000*60*60*24* 14
      return this.itTickets.filter((t) => !((t.bearbeiter && t.bearbeiter.id == userId) || (t.prio >= 4) || (t.updatedAt <= tooOld)))
    },
    isTicketer() {
      return this.user && this.user.person && this.user.person.ticketBearbeiter
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YY");
    },
    formatDateLong(date) {
      return moment(date).format("dddd DD. MMMM Y, HH:mm[Uhr]");
    },
    updatePagination(paginationName, pagination) {
      this[paginationName] = pagination
    }
  },
}
</script>
